import { ITriggerData, ITriggerGroup } from "../trigger";
import { IActionData, IActionJavaData } from "../action/IAction.intf";
import { IActionGroup } from "../action/IActionGroup.intf";
import { IProjectData } from "../project/IProject.data";
import { ITriggerAction } from "../trigger-action/ITriggerAction.intf";
import { ITriggerActionGroup } from "../trigger-action/ITriggerActionGroup";
import { getParent, ExtractedObjectTypeValues } from "@fanfanlo";
export interface IChildToProjectData{
    action?:IActionData<any, any>
    actionList?:IActionData<any, any>[]
    actionGroup?:IActionGroup

    trigger?:ITriggerData<any, any>
    triggerList?:ITriggerData<any, any>[]
    triggerGroup?:ITriggerGroup

    triggerAction?:ITriggerAction
    triggerActionList?:ITriggerAction[]
    triggerActionGroup?:ITriggerActionGroup

    project?:IProjectData
}
export function projectDataToUniqueId(data:IChildToProjectData):string{
    let s = ``
    function add(name:string, id?:string){if(id)s += `|${name}:${id}`}
    add('project', data.project?.id);
    add('trigger-action-group', data.triggerActionGroup?.id);
    add('trigger-action', data.triggerAction?.id);

    add('trigger-group', data.triggerGroup?.id);
    add('trigger', data.trigger?.id);
    add('trigger-java-data', data.trigger?.javaData?.id)
    
    add('action-group', data.actionGroup?.id);
    add('action', data.action?.id);
    add('action-java-data', data.action?.javaData?.id)
    return s;
}
// project
function getProjectByProp<T extends IProjectData = IProjectData>(prop:ExtractedObjectTypeValues<T>, projectData?:IChildToProjectData):T | undefined{
    const data = prop ? getParent<T>(prop) : undefined
    if(projectData) {
        projectData.project = data
    }
    return data
}

function getProjectElementByProp<T extends IProjectData = IProjectData>(prop:ExtractedObjectTypeValues<T>, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    getProjectByProp(prop, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}


// trigger action group
function getTriggerActionGroupByProp<T extends ITriggerActionGroup = ITriggerActionGroup>(prop:ExtractedObjectTypeValues<T>, projectData?:IChildToProjectData){
    const data = prop ? getParent<T>(prop) : undefined
    if(projectData && data){
        projectData.triggerActionGroup = data
        getProjectByProp(data, projectData)
    }
    return data
}
function getTriggerActionGroupElementByProp<T extends ITriggerActionGroup = ITriggerActionGroup>(prop:ExtractedObjectTypeValues<T>, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    getTriggerActionGroupByProp(prop, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}


function getTriggerActionGroupElement(triggerActionGroup:ITriggerActionGroup, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    projectData.triggerActionGroup = triggerActionGroup
    getTriggerActionGroupByProp(triggerActionGroup.checks, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}

// trigger action list
function getTriggerActionListByProp<T extends ITriggerAction = ITriggerAction>(prop:T, projectData?:IChildToProjectData){
    const data = prop ? getParent<T[]>(prop) : undefined
    if(projectData && data){
        projectData.triggerActionList = data
        getTriggerActionGroupByProp(data, projectData)
    }
    return data
}

function getTriggerActionListElementByProp<T extends ITriggerAction = ITriggerAction>(prop:T, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    getTriggerActionListByProp(prop, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}

// trigger action
function getTriggerActionByProp<T extends ITriggerAction = ITriggerAction>(prop:ExtractedObjectTypeValues<T>, projectData?:IChildToProjectData){
    const data = prop ? getParent<T>(prop) : undefined
    if(projectData && data){
        projectData.triggerAction = data
        getTriggerActionListByProp(data, projectData)
    }
    return data
}

function getTriggerActionElementByProp<T extends ITriggerAction = ITriggerAction>(prop:ExtractedObjectTypeValues<T>, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    getTriggerActionByProp(prop, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}

// trigger group
function getTriggerGroupByProp<T extends ITriggerGroup = ITriggerGroup>(prop:ExtractedObjectTypeValues<T>, projectData?:IChildToProjectData){
    const data = prop ? getParent<T>(prop) : undefined
    if(projectData && data){
        projectData.triggerGroup = data
        getTriggerActionByProp(data, projectData)
    }
    return data
}

function getTriggerGroupElementByProp<T extends ITriggerGroup = ITriggerGroup>(prop:ExtractedObjectTypeValues<T>, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    getTriggerGroupByProp(prop, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}

function getTriggerGroupElement(triggerGroup:ITriggerGroup, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    projectData.triggerGroup = triggerGroup
    getTriggerGroupByProp(triggerGroup.list, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}

// trigger list
export function getTriggerListByProp<T extends ITriggerData<any, any> = ITriggerData<any, any>>(prop:ExtractedObjectTypeValues<T>, projectData?:IChildToProjectData){
    const data = prop ? getParent<T[]>(prop) : undefined
    if(projectData && data){
        projectData.triggerList = data
        getTriggerGroupByProp(data, projectData)
    }
    return data
}

export function getTriggerListElementByProp<T extends ITriggerData<any, any> = ITriggerData<any, any>>(prop:ExtractedObjectTypeValues<T>, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    getTriggerListByProp(prop, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}

// trigger
export function getTriggerByProp<T extends ITriggerData<any, any> = ITriggerData<any, any>>(prop:ExtractedObjectTypeValues<T>, projectData?:IChildToProjectData){
    const data = prop ? getParent<T>(prop) : undefined
    if(projectData && data){
        projectData.trigger = data
        getTriggerListByProp(data, projectData)
    }
    return data
}

export function getTriggerElementByProp<T extends ITriggerData<any, any> = ITriggerData<any, any>>(prop:ExtractedObjectTypeValues<T>, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    getTriggerByProp(prop, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}
// 得想办法让它在数据不正确时报错才行
// getTriggerByProp({shellData:{}})
// getTriggerByProp({javaData:{}})
// getTriggerByProp(3)


// action group
export function getActionGroupByProp<T extends IActionGroup = IActionGroup>(prop:ExtractedObjectTypeValues<T>, projectData?:IChildToProjectData){
    const data = prop ? getParent<T>(prop) : undefined
    if(projectData && data){
        projectData.actionGroup = data
        getTriggerActionByProp(data, projectData)
    }
    return data
}

export function getActionGroupElementByProp<T extends IActionGroup = IActionGroup>(prop:ExtractedObjectTypeValues<T>, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    getActionGroupByProp(prop, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}

export function getActionGroupElement(actionGroup:IActionGroup, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    projectData.actionGroup = actionGroup
    getTriggerActionByProp(actionGroup, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}

// action list
export function getActionListByProp<T extends IActionData<any, any> = IActionData<any, any>>(prop:ExtractedObjectTypeValues<T>, projectData?:IChildToProjectData){
    const data = prop ? getParent<T[]>(prop) : undefined
    if(projectData && data){
        projectData.actionList = data
        getActionGroupByProp(data, projectData)
    }
    return data
}   
function getActionListElementByProp<T extends IActionData<any, any> = IActionData<any, any>>(prop:ExtractedObjectTypeValues<T>, prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    getActionListByProp(prop, projectData)
    return getProjectElementsId(projectData, prefix, suffix)
}

// action
function getActionByProp<T extends IActionData<any, any> = IActionData<any, any>>(prop:ExtractedObjectTypeValues<T>, projectData?:IChildToProjectData){
    const data = prop ? getParent<T>(prop) : undefined
    if(projectData && data){
        projectData.action = data
        getActionListByProp(data, projectData)
    }
    return data
}

function getActionElementIdByProp<T extends IActionData<any, any> = IActionData<any, any>>(prop:ExtractedObjectTypeValues<T>,prefix:string = '', suffix:string = '', projectData:IChildToProjectData = {}){
    getActionByProp(prop, projectData)
    return getProjectElementsId(projectData, prefix, suffix) 
}

function getProjectElementsId(childData:IChildToProjectData, prefix:string = '', suffix:string = ''){
    return {
        [`data-groupof${prefix ? '-'+prefix : ''}-project-id${suffix ? '-'+suffix : ''}`]: childData.project?.id,
        [`data-project-id`]:childData.project?.id,

        [`data-groupof${prefix ? '-'+prefix : ''}-trigger-action-group-id${suffix ? '-'+suffix : ''}`]: childData.triggerActionGroup?.id,
        [`data-trigger-action-group-id`]:childData.triggerActionGroup?.id,

        [`data-groupof${prefix ? '-'+prefix : ''}-trigger-action-id${suffix ? '-'+suffix : ''}`]: childData.triggerAction?.id,
        [`data-trigger-action-id`]:childData.triggerAction?.id,

        [`data-groupof${prefix ? '-'+prefix : ''}-trigger-group-id${suffix ? '-'+suffix : ''}`]: childData.triggerGroup?.id,
        [`data-trigger-group-id`]:childData.triggerGroup?.id,

        [`data-groupof${prefix ? '-'+prefix : ''}-trigger-id${suffix ? '-'+suffix : ''}`]: childData.trigger?.id,
        [`data-trigger-id`]:childData.trigger?.id,

        [`data-groupof${prefix ? '-'+prefix : ''}-action-group-id${suffix ? '-'+suffix : ''}`]: childData.actionGroup?.id,
        [`data-action-group-id`]:childData.actionGroup?.id,

        [`data-groupof${prefix ? '-'+prefix : ''}-action-id${suffix ? '-'+suffix : ''}`]: childData.action?.id,
        [`data-action-id`]:childData.action?.id
    }
}

export const childToProjectDataUtils = {
    project:{
        getProjectByProp,
        getProjectElementByProp
    },
    triggerActionGroup:{
        getTriggerActionGroupByProp,
        getTriggerActionGroupElementByProp,
        getTriggerActionGroupElement,
    },
    triggerActionList:{
        getTriggerActionListByProp,
        getTriggerActionListElementByProp,
    },
    triggerAction:{
        getTriggerActionByProp,
        getTriggerActionElementByProp,
    },
    triggerGroup:{
        getTriggerGroupByProp,
        getTriggerGroupElementByProp,
        getTriggerGroupElement
    },
    trigger:{
        getTriggerByProp,
        getTriggerElementByProp,
    },
    triggerList:{
        getTriggerListByProp,
        getTriggerListElementByProp,
    },
    actionGroup:{
        getActionGroupByProp,
        getActionGroupElementByProp,
        getActionGroupElement,
    },
    actionList:{
        getActionListByProp,
        getActionListElementByProp,
    },
    action:{
        getActionByProp,
        getActionElementIdByProp
    },
    getProjectElementsId
}